import type { Quote } from './parser'

import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

export type Props = {
  quotes: Quote[]
}

function QuoteList({ quotes }: Props) {
  return (
    <div className={style.wrapper}>
      {quotes.map(({ name, affiliation, quote }, index) => (
        <blockquote key={index} className={style.card}>
          <Paragraph className={style.quote}>{quote}</Paragraph>
          {name && (
            <Paragraph small>
              <span className={style.name}>{name}</span>
              {affiliation && (
                <span className={style.affiliation}>, {affiliation}</span>
              )}
            </Paragraph>
          )}
        </blockquote>
      ))}
    </div>
  )
}

export default QuoteList
